import { Injectable } from '@angular/core';
import { UserType } from '../types/ip-user-type';
import { IpSnackbarService } from './ip-snackbar.service';
import { RoleResponse } from '../interfaces/ip-role-response';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IpPermissionResponse } from '../interfaces/ip-permission-response';
import { AllMenuListBrokerResponse } from '../interfaces/ip.menu-list-broker';

@Injectable({
  providedIn: 'root',
})
export class IpRoleService {
  private api = environment.api;
  private menuListBroker: AllMenuListBrokerResponse[] = [];

  constructor(
    private http: HttpClient,
    private ipSnackbarService: IpSnackbarService
  ) {}

  getType(): 'business' | 'employee' | 'provider' {
    const userType = this.getUserType();
    switch (userType) {
      case 'ENTERPRISE_MANAGER':
      case 'ENTERPRISE_ADMIN':
      case 'ENTERPRISE_USER':
        return 'business';
      case 'SUPPLIER_MANAGER':
      case 'BROKER_MANAGER':
      case 'SUPPLIER_USER':
        return 'provider';
      case 'EMPLOYEE':
        return 'employee';
      default:
        this.ipSnackbarService.showUnexpectedErrorMessage();
        throw new Error('Unexpected user type.');
    }
  }

  getUserType(): UserType {
    return sessionStorage.getItem('userType') as UserType;
  }

  getUserPermission(): Observable<RoleResponse> {
    return this.http.get<RoleResponse>(
      `${this.api}/invopay/enterprise/roles/permissions`
    );
  }

  getAllPermissions(): Observable<IpPermissionResponse[]> {
    return this.http.get<IpPermissionResponse[]>(
      `${this.api}/invopay/permission`
    );
  }

  getIsBroker(){
    if(sessionStorage.getItem('isBroker')){
      if(sessionStorage.getItem('isBroker') === "true"){
        return true
      }
    }
    if(sessionStorage.getItem('userType')){
      if(sessionStorage.getItem('userType') === "BROKER_MANAGER"){
        return true
      }
    }
    return false
  }

  getAllMenuListBroker(): Observable<AllMenuListBrokerResponse[]> {
    return this.http.get<AllMenuListBrokerResponse[]>(`${this.api}/invopay/permission/menu-brokers`);
  }

  // TODO: translate
  getUserFriendlyType() {
    const userType = this.getUserType();
    switch (userType) {
      case 'ENTERPRISE_MANAGER':
        return 'Gerente de la matriz';
      case 'ENTERPRISE_ADMIN':
        return 'Gerente de subsidiaria';
      case 'ENTERPRISE_USER':
        return 'Usuario admin de la empresa'; 
      case 'SUPPLIER_MANAGER':
        return 'Gerente proveedor';
      case 'BROKER_MANAGER':
        return 'Agente de ventas';
      case 'SUPPLIER_USER':
        return 'Usuario proveedor';
      case 'EMPLOYEE':
        return 'Empleado';
      case 'ADMIN_INVOPAY':
        return 'Admin. del sistema';
      default:
        throw new Error('Unexpected user type.');
    }
  }

  b64DecodeUnicode(str: string) {
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }

  setMenuListBroker(menuList: AllMenuListBrokerResponse[]){
    this.menuListBroker = menuList;
  }

  getMenuListBroker(){
    return this.menuListBroker;
  }
}
